import { createContext, useContext } from "react";

// Gedeelde verwerkingsstatus (Overzicht-dashboard + sidebar-badges).
// De provider met echte data staat in features/overview; deze context
// levert een veilige default zodat de sidebar zonder provider werkt.
const ProcessStatusContext = createContext({
  status: null,
  loading: false,
  error: null,
  badges: {},
  refresh: () => {},
});

export function useProcessStatus() {
  return useContext(ProcessStatusContext);
}

export default ProcessStatusContext;
